<template>
  <div class="border-b border-border-light pb-4">
    <button
      class="flex w-full items-center justify-between gap-4"
      :aria-label="`Toggle Collapse ${title}`"
      @click="toggle"
    >
      <span class="font-poppins text-display-md font-extrabold text-text-dark">
        {{ title }}
      </span>
      <BaseIcon
        :class="{
          'rotate-180': isOpen,
        }"
        class="size-6 transition-transform duration-300"
        :icon="'ChevronDown'"
      ></BaseIcon>
    </button>

    <Transition @enter="enter" @after-enter="afterEnter" @leave="leave" @after-leave="afterLeave">
      <ul v-show="isOpen" class="mt-2">
        <li
          v-for="(option, index) in options"
          :key="index"
          class="border-b border-border-light py-2"
        >
          <a
            :href="option.value"
            :aria-label="option.label"
            class="text-sm text-text-dark no-underline"
          >
            {{ option.label }}
          </a>
        </li>
      </ul>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import BaseIcon from '@/common/components/base/BaseIcon/BaseIcon.vue'
import type { INavMobileOverlayCollapse } from '@/features/navigation/components/NavMobileOverlay/types/INavMobileOverlayCollapse.ts'
import gsap from 'gsap'

defineProps<INavMobileOverlayCollapse>()

const isOpen = defineModel({
  type: Boolean,
  required: true,
})

const toggle = () => {
  isOpen.value = !isOpen.value
  emit('change', isOpen.value)
}

const emit = defineEmits<{
  (e: 'change', value: boolean): void
}>()

//#region animation
const enter = (el: Element, done: gsap.Callback) => {
  gsap.from(el, {
    height: 0,
    opacity: 0,
    duration: 0.3,
    ease: 'power1.out',
    onComplete: done,
  })
}

const afterEnter = (el: Element) => {
  gsap.set(el, { clearProps: 'height,opacity' })
}

const leave = (el: Element, done: gsap.Callback) => {
  gsap.to(el, {
    height: 0,
    opacity: 0,
    duration: 0.3,
    ease: 'power1.in',
    onComplete: done,
  })
}

const afterLeave = (el: Element) => {
  gsap.set(el, { clearProps: 'height,opacity' })
}
//#endregion
</script>
